module.exports = __webpack_public_path__ + "img/partner5.344fef40.png";